<template>
  <!-- Lớp phủ tối phía sau menu khi mở trên mobile -->
  <div v-if="isMobile && isOpen" class="drawer-overlay" @click="closeMenu"></div>
  <div id="kt_aside" class="aside pt-7 pb-4 pb-lg-7 pt-lg-17"
       :class="{ 'drawer drawer-start': isMobile, 'drawer-on': isMobile && isOpen }"
       :style="asideStyle"
  >
    <!--begin::Brand-->
    <div class="aside-logo flex-column-auto px-9 mb-9 mb-lg-17 mx-auto" id="kt_aside_logo">
      <!--begin::Logo-->
      <a href="/">
<!--        <img alt="Logo" src="@/assets/images/logo_v2.svg" class="h-70px logo"/>-->
      </a>
      <!--end::Logo-->
    </div>
    <!--end::Brand-->
    <!--begin::Aside user-->
    <div class="aside-user mb-5 mb-lg-10" id="kt_aside_user">
      <!--begin::User-->
      <div class="d-flex align-items-center flex-column">
        <!--begin::Symbol-->
        <div class="symbol symbol-75px mb-4">
          <img src="@/assets/media/avatars/150-26.jpg" alt=""/>
        </div>
        <!--end::Symbol-->
        <!--begin::Info-->
        <div class="text-center">
          <!--begin::Username-->
          <a href="/"
             class="text-gray-900 text-hover-primary fs-4 fw-boldest">{{ name }}</a>
          <!--end::Username-->
          <!--begin::Description-->
          <span class="text-gray-600 fw-bold d-block fs-7 mb-1">{{email}}</span>
          <!--end::Description-->
        </div>
        <!--end::Info-->
      </div>
      <!--end::User-->
    </div>
    <!--end::Aside user-->
    <!--begin::Aside menu-->
    <div class="aside-menu flex-column-fluid ps-3 ps-lg-5 pe-1 mb-9" id="kt_aside_menu">
      <!--begin::Aside Menu-->
      <div class="w-100 hover-scroll-overlay-y pe-2 me-2" id="kt_aside_menu_wrapper" data-kt-scroll="true"
           data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto"
           data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_user, #kt_aside_footer"
           data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu, #kt_aside_menu_wrapper" data-kt-scroll-offset="0">
        <!--begin::Menu-->
        <div class="menu menu-column menu-rounded fw-bold" id="#kt_aside_menu" data-kt-menu="true">
          <template v-for="(m, index) in this.menu" :key="index">
            <!-- Mục có menu con -->
            <div v-if="m.children" class="menu-item">
              <a href="javascript:void(0)" class="menu-link" :class="{active: isGroupActive(m) && !isGroupOpen(m, index)}"
                 @click="toggleGroup(index)">
                <span class="menu-title">{{ m.title }}</span>
                <i class="bi menu-group-arrow" :class="isGroupOpen(m, index) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </a>
              <div v-show="isGroupOpen(m, index)" class="menu-sub-list">
                <div class="menu-item" v-for="c in m.children" :key="c.name">
                  <router-link class="menu-link" :class="this.$route.name === c.name ? 'active' : ''" :to="{ name: c.name }">
                    <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                    <span class="menu-title">{{ c.title }}</span>
                  </router-link>
                </div>
              </div>
            </div>
            <div v-else class="menu-item">
              <router-link class="menu-link" :class="this.$route.name === m.name ? 'active' : ''" :to="{ name: m.name }"><span class="menu-title" >{{ m.title }}</span></router-link>
            </div>
          </template>

        </div>
        <!--end::Menu-->
      </div>
      <!--end::Aside Menu-->
    </div>
    <!--end::Aside menu-->
    <!--begin::Footer-->
    <div class="aside-footer flex-column-auto px-6 px-lg-9" id="kt_aside_footer">
      <!--begin::User panel-->
      <div class="d-flex flex-stack ms-7">
        <!--begin::Link-->
        <a href="javascript:void(0)"
           class="btn btn-sm btn-icon btn-active-color-primary btn-icon-gray-600 btn-text-gray-600">
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr076.svg-->
          <span class="svg-icon svg-icon-1 me-2">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<rect opacity="0.3" width="12" height="2" rx="1" transform="matrix(-1 0 0 1 15.5 11)" fill="black"/>
										<path
                        d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                        fill="black"/>
										<path
                        d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                        fill="#C4C4C4"/>
									</svg>
								</span>
          <!--end::Svg Icon-->
          <!--begin::Major-->
          <span class="d-flex flex-shrink-0 fw-bolder" @click="logout()">Đăng xuất</span>
          <!--end::Major-->
        </a>
        <!--end::Link-->
      </div>
      <!--end::User panel-->
    </div>
    <!--end::Footer-->
  </div>
</template>


<script>
import menu from '@/constants/menu';
import {mapActions} from "vuex";

// Trùng breakpoint "lg" của Metronic: dưới 992px thì menu thành drawer
const MOBILE_BREAKPOINT = 992;
export default {
  name: 'MenuSite',
  props: {
  },
  data() {
    return {
      menu: menu,
      name: localStorage.getItem('name'),
      email: localStorage.getItem('email'),
      isOpen: false,
      isMobile: window.innerWidth < MOBILE_BREAKPOINT,
      // Nhóm menu đang mở/đóng do người dùng bấm (index → true/false)
      openGroups: {},
    };
  },
  computed: {
    asideStyle() {
      const style = {overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none'};
      if (this.isMobile) {
        style.width = window.innerWidth >= 300 ? '250px' : '200px';
      }
      return style;
    }
  },
  watch: {
    // Chuyển trang thì đóng menu
    '$route'() {
      this.closeMenu();
    },
    isOpen(open) {
      // Khoá cuộn trang phía sau khi menu đang mở
      document.body.style.overflow = open ? 'hidden' : '';
    }
  },
  mounted() {
    // Nút ☰ (#kt_aside_toggle) nằm trong từng trang và bị vẽ lại khi đổi trang,
    // nên bắt sự kiện click ở cấp document thay vì gắn trực tiếp vào nút.
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('resize', this.onResize);
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions(['doLogout']),
    async logout() {
      await this.doLogout();
      await this.$router.push('/login');
    },
    onDocumentClick(e) {
      if (e.target.closest && e.target.closest('#kt_aside_toggle')) {
        this.isOpen = !this.isOpen;
      }
    },
    onKeydown(e) {
      if (e.key === 'Escape') this.closeMenu();
    },
    onResize() {
      this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      if (!this.isMobile) this.closeMenu();
    },
    closeMenu() {
      this.isOpen = false;
    },
    isGroupActive(m) {
      return m.children.some((c) => c.name === this.$route.name);
    },
    // Nhóm chứa trang hiện tại thì mặc định mở, trừ khi người dùng đã tự đóng
    isGroupOpen(m, index) {
      if (index in this.openGroups) return this.openGroups[index];
      return this.isGroupActive(m);
    },
    toggleGroup(index) {
      const m = this.menu[index];
      this.openGroups = {...this.openGroups, [index]: !this.isGroupOpen(m, index)};
    }
  }
}
</script>

<style scoped>
.menu-group-arrow {
  margin-left: auto;
  font-size: 12px;
  color: #a1a5b7;
}
.menu-sub-list .menu-link {
  padding-left: 2.25rem;
}
.menu-sub-list .menu-bullet {
  margin-right: 8px;
}
</style>
